<div id="step-action-container">
    <div id="action-icon">
        <fa-icon icon="long-arrow-alt-up"></fa-icon>
        <fa-icon icon="long-arrow-alt-down"></fa-icon>
    </div>
    <div id="action-content">
        <ng-content></ng-content>
    </div>
</div>
